import * as ambassadorWixDevcenterAppInstanceV1AppInstance from './devcenter-app-instance-v1-app-instance-app-instances.http.js';
import * as ambassadorWixDevcenterAppInstanceV1AppInstanceTypes from './devcenter-app-instance-v1-app-instance-app-instances.types.js';
import * as ambassadorWixDevcenterAppInstanceV1AppInstanceUniversalTypes from './devcenter-app-instance-v1-app-instance-app-instances.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getAppInstance(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixDevcenterAppInstanceV1AppInstanceUniversalTypes.GetAppInstanceRequest,
  ambassadorWixDevcenterAppInstanceV1AppInstanceTypes.GetAppInstanceRequest,
  ambassadorWixDevcenterAppInstanceV1AppInstanceUniversalTypes.GetAppInstanceResponse,
  ambassadorWixDevcenterAppInstanceV1AppInstanceTypes.GetAppInstanceResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixDevcenterAppInstanceV1AppInstance.getAppInstance(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/instance',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  AppInstance as AppInstanceOriginal,
  BillingInfo as BillingInfoOriginal,
  PaymentCycle as PaymentCycleOriginal,
  PaymentCycleWithLiterals as PaymentCycleWithLiteralsOriginal,
  FreeTrialInfo as FreeTrialInfoOriginal,
  FreeTrialStatus as FreeTrialStatusOriginal,
  FreeTrialStatusWithLiterals as FreeTrialStatusWithLiteralsOriginal,
  AvailablePlan as AvailablePlanOriginal,
  AppInstalled as AppInstalledOriginal,
  AppRemoved as AppRemovedOriginal,
  PaidPlanPurchased as PaidPlanPurchasedOriginal,
  PaidPlanChanged as PaidPlanChangedOriginal,
  PaidPlanAutoRenewalCancelled as PaidPlanAutoRenewalCancelledOriginal,
  FreeTrialPeriod as FreeTrialPeriodOriginal,
  FreeTrialPeriodWithLiterals as FreeTrialPeriodWithLiteralsOriginal,
  PlanTransferred as PlanTransferredOriginal,
  PlanReactivated as PlanReactivatedOriginal,
  ReactivationReason as ReactivationReasonOriginal,
  ReactivationReasonWithLiterals as ReactivationReasonWithLiteralsOriginal,
  PlanConvertedToPaid as PlanConvertedToPaidOriginal,
  GetAppInstanceRequest as GetAppInstanceRequestOriginal,
  GetAppInstanceResponse as GetAppInstanceResponseOriginal,
  SiteInfo as SiteInfoOriginal,
  Multilingual as MultilingualOriginal,
  SupportedLanguage as SupportedLanguageOriginal,
  Locale as LocaleOriginal,
  ResolutionMethod as ResolutionMethodOriginal,
  ResolutionMethodWithLiterals as ResolutionMethodWithLiteralsOriginal,
  OwnerInfo as OwnerInfoOriginal,
  GetAppInstanceByInstanceIdRequest as GetAppInstanceByInstanceIdRequestOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './devcenter-app-instance-v1-app-instance-app-instances.types.js';
